import { G_GRAPH__DRAG_AND_DROP__image_internal } from '@/pages/page_generation/layouts/nodes/node/fields/image/_base/_drag_and_drop/G_GRAPH__DRAG_AND_DROP__image_internal';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { GENERATION_TOOL__vision__hed } from '@shared/dto/generation/graph_invoke/_templates/vision__line_hed/GENERATION_TOOL__vision__hed';
import { G_BUTTON__image_asset_create_with_generation } from '../_buttons/G_BUTTON__image_asset_create_with_generation';
import { G_BUTTON__image_asset_select_from_existing } from '../_buttons/G_BUTTON__image_asset_select_from_existing';
import { HOOK__image_aspect_ratio_for_generation_provider } from '../_hooks/HOOK__image_aspect_ratio_for_generation_provider';
import { G_UI_FIELD__image_asset_empty_base } from './G_UI_FIELD__image_asset_empty_base';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_UI_FIELD__image_asset_empty_control_line_soft_edge({ field }: PROPS) {
  let grid2d_cell__aspect_ratio = HOOK__image_aspect_ratio_for_generation_provider(field);
  let { hash_sha256_content } = field;

  return (
    <G_UI_FIELD__image_asset_empty_base>
      <>
        <G_BUTTON__image_asset_select_from_existing {...{ field }} />
        <G_BUTTON__image_asset_create_with_generation
          {...{ field_consumer: field }}
          generation_tool={GENERATION_TOOL__vision__hed({ hash_sha256_content, grid2d_cell__aspect_ratio })}
        />

        <G_GRAPH__DRAG_AND_DROP__image_internal {...{ field }} />
      </>
    </G_UI_FIELD__image_asset_empty_base>
  );
}
